export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7382.b334c6c4.jpg";